/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from 'react';
import { Button, Card, Row } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import printer from '../../../../assets/printer.png';
import { usePoStock } from '../ContextAPI';
import ComponentToPrint from './ComponentToPrint';

export default function PrintIndex() {
    const {
        setShowList,
        setShowForm,
        setShowPdfList,
        setShowDetails,
        setPendingDetailsShow,
        setShowPdfDetails,
    } = usePoStock();
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleClose = () => {
        setShowList(true);
        setShowForm(false);
        setShowDetails(false);
        setPendingDetailsShow(false);
        setShowPdfList(false);
        setShowPdfDetails(false);
    };

    return (
        <Card>
            <Card.Header className="cardHeader">
                <div>
                    <Button className="btn btn-light me-2" onClick={handlePrint}>
                        {/* <i className="fa fa-file-pdf" /> */}
                        <img style={{ width: '22px' }} src={printer} alt="" />
                    </Button>
                    <Button onClick={() => handleClose()} className="btnInfo" variant="primary">
                        Go Back
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <ComponentToPrint ref={componentRef} />
                </Row>
            </Card.Body>
        </Card>
    );
}
